export default __webpack_public_path__ + "static/media/amazon-connect-error.f15962e4.svg";